module.exports = __webpack_public_path__ + "img/arrow-down-s-fill.acb3824c.svg";